export default {
  RO_UNSETTLED: {
    value: 0,
    label: '申请中',
  },
  RO_CANCELLED: {
    value: 1,
    label: '已取消',
  },
  RO_REFUND: {
    value: 2,
    label: '已退款',
  },
  RO_REFUSE: {
    value: 3,
    label: '已拒绝',
  },
  RO_AGREE_RETURN: {
    value: 4,
    label: '待买家寄回',
  },
  RO_SHIPPED: {
    value: 5,
    label: '买家已寄回',
  }
}
